import {
    applyMiddleware,
    combineReducers,
    compose,
    createStore,
    Dispatch,
} from "redux";
import createSagaMiddleware from "redux-saga";
import reducers from "@/Redux/Reducers";
import sagas from "@/Redux/Sagas";
import { createBrowserHistory } from "history";
import { createReduxHistoryContext } from "redux-first-history";
import { composeWithDevTools } from "redux-devtools-extension";

import {
    RootStateOrAny,
    TypedUseSelectorHook,
    useDispatch,
    useSelector,
} from "react-redux";
import { APP_INIT_SAGA } from "@/Redux/App/AppConstants";

export let dispatch: Dispatch | null = null;

// @ts-ignore
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const { createReduxHistory, routerMiddleware, routerReducer } = createReduxHistoryContext({ 
    history: createBrowserHistory(),
    //other options if needed 
  });

let store: any;

export const initRedux = () => {
    // @ts-ignore
    //reducers.router = connectRouter(history);
    //let reducer = combineReducers(reducers);



    const sagaMiddleware = createSagaMiddleware();
    const middlewares = [sagaMiddleware, routerMiddleware];

    const reducer = combineReducers(reducers);

    store = createStore(
        reducer,
        composeEnhancers(applyMiddleware(...middlewares)),
    );

    dispatch = store.dispatch;
    sagaMiddleware.run(sagas);

    store.dispatch({ type: APP_INIT_SAGA });
    return { store, history };
};

export const selectBrowserNotification = (state: RootStateOrAny) => {
    return state.browserNotification;
};

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<any> = useSelector;

export type AppStore = ReturnType<typeof store>;
